<div class="panel panel-font gradient-bg">
  <span class="panel-title">{{ 'Vyhledání odjezdů ze zastávky' | translate }}</span>
  <a [routerLink]="'/'" class="closeBtn" title="{{ 'zavřít' | translate }}"></a>
  <app-search-input [inputData]="state.searchText" [placeholder]="'Název zastávky...'" (search)="onSearch($event)" />

  <div *ngIf="loading">
    <app-loading></app-loading>
  </div>

  <div *ngIf="state.searchedStops.length > 0 && !loading">
    <ul class="mainList">
      <li *ngFor="let stop of state.searchedStops" [routerLink]="['/departures', stop.id]"
          (mouseenter)="startHover(stop.id)" (mouseleave)="endHover(stop.id)">
        <div class="panel-section clickable clickable-list">
          <div class="d-flex">
            <div class="icon{{stop.sourceType}}new iconDiv">
              <span></span>
            </div>
            <div class="ml1">
              <div class="section-title">{{stop.name}}</div>
              <div>{{ getTypeDescription(stop) | translate }}</div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div class="panel-subtitle mt4" *ngIf="state.searchedStops.length == 0 && term && !loading">
    {{ 'Nebyla nalezena žádná zastávka s tímto názvem.' | translate }}
  </div>

  <div *ngIf="state.searchedStops.length == 0 && lastSearchResult.length > 0 && !loading">
    <div class="panel-subtitle mt4">{{ 'Naposledy hledané zastávky' | translate }}:</div>
    <ul class="mainList">
      <li *ngFor="let stop of lastSearchResult" [routerLink]="['/departures', stop.id]"
          (mouseenter)="startHover(stop.id)" (mouseleave)="endHover(stop.id)">
        <div class="panel-section clickable clickable-list">
          <div class="d-flex">
            <div class="icon{{stop.sourceType}}new iconDiv">
              <span></span>
            </div>
            <div class="ml1">
              <div class="section-title">{{stop.name}}</div>
              <div>{{ getTypeDescription(stop) | translate }}</div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
